export interface Crop {
  id: string;
  name: string;
  image_url: string;
  is_transplanted: boolean;
  app_display_name: string;
}

export interface CropsWithCategory {
  category: string;
  crops: Crop[];
}

export enum AdvisoryQueryType {
  CROP = "CROP",
  LOCATION = "LOCATION",
  SOWING_DATE = "SOWING_DATE",
  STAGE = "STAGE",
}

export enum QueryName {
  Crop = "Crop",
  Location = "Location",
  SowingDate = "Sowing Date",
  TransplantedDate = "Transplantation Date",
}

export interface CropDataPoint {
  id: number;
  query_name: QueryName;
  query_type: AdvisoryQueryType;
  value: {
    id: number;
    image: string;
    name: string;
  };
}

export interface SowingDataPoint {
  id: number;
  query_name: QueryName;
  query_type: AdvisoryQueryType;
  value: string;
}
export type DataPoint = CropDataPoint | SowingDataPoint;

export interface SubScribedCrops {
  id: string;
  plan_id: number;
  user_id: number;
  data_points: DataPoint[];
  status: string;
  is_active: boolean;
}

type AdvisoryDataPoint = {
  id: number;
  query_name: string;
  query_type: "CROP" | "LOCATION" | "SOWING_DATE" | string; // Add other possible query types as needed
  value:
    | { id: number; image: string; name: string } // For CROP
    | string; // For LOCATION, SOWING_DATE, etc.
};

export type AdvisoryResponse = {
  id: string;
  plan_id: number;
  user_id: number;
  created_at: string; // ISO date string
  updated_at: string; // ISO date string
  data_points: AdvisoryDataPoint[];
  status: "PENDING" | "COMPLETED" | "FAILED" | string; // Add other possible statuses as needed
};
